<template>
  <div class="mini-grid">
    <div>
      <el-button type="primary" @click="printpage()">打印</el-button>
      <!-- <el-button type="success" @click="start_page()">上一页</el-button>
      <el-button type="success" @click="end_page()">下一页</el-button> -->
      <el-button type="danger" @click="close()">关闭</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "print_kpqrd",
  data() {
    return {
      JLBH:new URLSearchParams(window.location.search).get('JLBH'),
      HSFS:new URLSearchParams(window.location.search).get('HSFS'),
    };
  },
  methods: {
    close(){
        window.close();
    },
    printpage(){//打印
      let printStr = "<html><head><meta http-equiv='Content-Type' content='text/html;charset=utf-8'></head><body >";
      let content = "";
      let sprnstr = "<!--startprint1-->";//设置打印开始区域
      let eprnstr = "<!--endprint1-->";//设置打印结束区域
      content = content+sprnstr ;//加载打印头

      //纵向：@page { size: portrait; }
      //横向：@page { size: landscape; }
      let sss= "<style"+" type="+"text/css"+">"+"@page { size: auto;margin-top: 5mm;margin-left: 10mm;}"+"body{ zoom:70%;padding: 0px 32px; }"+"</style>" ;
      content+=sss;
      if($("#ipt_count").val()==0){
          $("#ipt_count").val(1);
      }
      let num=$("#ipt_count").val();//打印的页数
      //判断是否只有1页要打印
      if(num==1){
          //只打印一页，是否打印子表
          if( $("#div_box").val()==0 ){
              content+=document.getElementById('model0').innerHTML;
              //let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              //content+=str;
              content+=document.getElementById('model2').innerHTML;
          }else{
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              content+=document.getElementById('model2').innerHTML;
          }

      }else{//不止要打印一份
          for (let i=0;i<num;i++){
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model'+i).innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              if( (i+1)%2==0 ){
                  content+=document.getElementById('model3').innerHTML;
              }else{
                  content+=document.getElementById('model2').innerHTML;
                  content+="<div"+" style='width:100%;height:150px;'"+"></div>";//加空格
              }

          }
      }

      content = content + eprnstr;//加载打印尾
      printStr = printStr+content+"</body></html>";
      let pwin=window.open("Print.htm","print"); //如果是本地测试，需要先新建Print.htm，如果是在域中使用，则不需要
      pwin.document.write(content);
      pwin.document.close();                   //这句很重要，没有就无法实现
      pwin.print();
      window.location.reload();
    },
    start_page(){//上一页
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在上一页");
          return;
      }
      if( $("#ipt").val() == 0 ){
          alert("当前页已经是最前一页");
          return;
      }else{
          $("#ipt").val(  $("#ipt").val()-1  );
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("div_model"+page_number ).style.display="";//显示
          page_number++;
          document.getElementById("div_model"+page_number ).style.display="none";//隐藏
      }
    },
    end_page(){//下一页
      let num=$("#ipt_count").val();
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在下一页");
          return;
      }
      //如果显示的是model0
      if( $("#ipt").val() == num-1 ){
          alert("当前页已经是最后一页");
          return;
      }else{
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("div_model"+page_number ).style.display="none";//隐藏
          page_number++;
          $("#ipt").val(page_number);
          document.getElementById("div_model"+page_number ).style.display="";//显示
      }
    },
    showDJ(data,HSFS){//展示单据
      //alert(data[1].length);
      //定义一个数组来存储子表数据
      let  son_list=new Array();
      let  count = 0;
      if(data[1]==""){
          count=0;
      }else{
          count = Math.ceil( (data[1].length)/7 );//记录子表数据有几页
      }

      let sss="";
      // sss+="<div"+" align='center'"+" width='100%'"+">";

      if( HSFS!="租赁" ){
          let people=data[0][0].DYR;//联系人
          let phone=data[0][0].LXDH;//联系电话

          if(data[0][0].LXDH==null || data[0][0].LXDH==""){
              phone="";
          }
          if(data[0][0].DYR==null || data[0][0].DYR==""){
              people="";
          }

          sss+="<table"+"   id=tab_0"+" width=100%"+" style='border-collapse:collapse;'"+">"+
              "<tr>"+
              "<td "+" style='text-align:center;font-size:20px;'"+"   colspan=8"+" align='center'"+">"+"开 票 确 认 单"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=6"+" align='right'"+" style='font-size:15px;'"+">"+data[5][0].RQ+"</td>"+
              "<td"+" colspan=2"+" style='font-size:15px;'"+">"+"开票数"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=2"+" style='font-size:15px;'"+">"+"交  增  值  税  发  票  时  间"+"</td>"+
              "<td"+" colspan=4"+" style='font-size:15px;'"+" align=right"+">"+data[4][0].RQ+"</td>"+
              "<td"+" colspan=2"+" style='font-size:15px;'"+" align=left"+">"+"前"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=8"+" style='font-size:15px;'"+">"+"（开票金额中未包括代扣费用）注：如未按以上时间交票，则销售货款结算延顺至下一期。开具增值税发票"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=8"+" style='font-size:15px;'"+">"+"“货物或应税劳务名称”至少填写所售货物5项分类（或附销货清单），否则拒收该增值税票。 "+"</td>"+
              "</tr></table>";

          sss+="<table"+"   id=tab_1"+" width=100%"+"  style='border-collapse:collapse;font-size: 16px;'"+">"+
              "<tr>"+
              "<td"+" align='center'"+">"+"商户名称:"+"</td>"+
              "<td"+" align='center'"+">"+data[0][0].GHDW+"</td>"+
              "<td"+" align='center'"+">"+"品牌"+"</td>"+
              "<td"+" align='center'"+">"+data[0][0].PP+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" align='center'"+">"+"代码"+"</td>"+
              "<td"+" align='center'"+">"+data[0][0].HTH+"</td>"+
              "<td"+" align='center'"+">"+"月保底销售额"+"</td>"+
              "<td"+" align='center'"+">"+data[2][0].BDXSJH+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" align='center'"+">"+"销售金额"+"</td>"+
              "<td"+" align='center'"+">"+"会员折扣"+"</td>"+
              "<td"+" align='center'"+">"+"合同扣率"+"</td>"+
              "<td"+" align='center'"+">"+"场地收益金"+"</td>"+
              "</tr>";
          console.log("这个有-------"+data[13].length+"条"+data[13]);

          for(let k=0;k<data[13].length;k++){
              let htxs=data[13][k].HTXS;//销售金额
              let VIPZKJE=data[13][k].VIPZKJE;//
              let JSKL_HT=data[13][k].JSKL_HT;//
              let KKJE=data[13][k].KKJE;//

              if(htxs==null || htxs==""){
                  htxs="";
              }

              if(htxs=="" && VIPZKJE=="" && JSKL_HT=="" && KKJE==""){
                  sss+="</table>";
              }else{
                  sss+="<tr>"+
                      "<td"+" align='center'"+">"+htxs+"</td>"+
                      "<td"+" align='center'"+">"+VIPZKJE+"</td>"+
                      "<td"+" align='center'"+">"+JSKL_HT+"</td>"+
                      "<td"+" align='center'"+">"+KKJE+"</td>"+
                      "</tr>";
              }
              if(k==data[13].length-1){
                  sss+="</table>";
              }
          }



          sss+="<table"+"   id=tab_2"+" width=100%"+"  style='border-collapse:collapse;font-size: 16px;'"+">"+
              "<tr>"+
              "<td"+" align='center'"+">"+"补（退）销"+"</td>"+
              "<td"+" align='center'"+">"+"保底清算"+"</td>"+
              "<td"+" align='center'"+">"+"签呈降扣"+"</td>"+
              "<td"+" align='center'"+">"+"合同降扣"+"</td>"+
              "<td"+" align='center'"+">"+"九折补偿"+"</td>"+
              "<td"+" align='center'"+">"+"会员储点"+"</td>"+
              "<td"+" align='center'"+">"+"积分加抽"+"</td>"+
              "<td"+" align='center'"+">"+"提货卡代金券"+"</td>"+
              "</tr>";

          console.log("不推销有几行"+data[3].length);
          console.log(data[3][0]==null );
          for(let i=0;i<data[3].length;i++){
              let BTX="";
              let BDQS="";
              let QCJK="";
              let HTJK="";
              let JZBC="";
              let HYCD="";
              let JFJC="";
              let SPTG="";

              if(data[3][i]==null){
                  let BTX="";
                  let BDQS="";
                  let QCJK="";
                  let HTJK="";
                  let JZBC="";
                  let HYCD="";
                  let JFJC="";
                  let SPTG="";
              }else{
                    BTX=data[3][i].BTX;
                    BDQS=data[3][i].BDQS;
                    QCJK=data[3][i].QCJK;
                    HTJK=data[3][i].HTJK;
                    JZBC=data[3][i].JZBC;
                    HYCD=data[3][i].HYCD;
                    JFJC=data[3][i].JFJC;
                    SPTG=data[3][i].SPTG;
              }
              console.log(BTX+"--"+BDQS+"--"+QCJK+"--"+HTJK+"--"+JZBC+"--"+HYCD+"--"+JFJC+"--"+SPTG);

            /* if(BTX==null){
                  BTX="";
              }
              if(BDQS==null){
                  BDQS="";
              }
              if(QCJK==null){
                  QCJK="";
              }
              if(HTJK==null){
                  HTJK="";
              }
              if(JZBC==null){
                  JZBC="";
              }
              if(HYCD==null){
                  HYCD="";
              }
              if(JFJC==null){
                  JFJC="";
              }
              if(SPTG==null){
                  SPTG="";
              }*/
              if(BTX==null && BDQS==null && QCJK==null && HTJK==null && JZBC==null && HYCD==null && JFJC==null && SPTG==null){
                  console.log("123");
              }else{
                  sss+="<tr>"+
                      "<td"+" align='center'"+">"+BTX+"</td>"+
                      "<td"+" align='center'"+">"+BDQS+"</td>"+
                      "<td"+" align='center'"+">"+QCJK+"</td>"+
                      "<td"+" align='center'"+">"+HTJK+"</td>"+
                      "<td"+" align='center'"+">"+JZBC+"</td>"+
                      "<td"+" align='center'"+">"+HYCD+"</td>"+
                      "<td"+" align='center'"+">"+JFJC+"</td>"+
                      "<td"+" align='center'"+">"+SPTG+"</td>"+
                      "</tr>";
              }

          }
          sss+= "</table><table"+" id=tab_3"+" width=100%"+" style='border-collapse:collapse;font-size: 16px;'"+">"+
          "<tr>"+
          "<td"+" align='center'"+" style='width:10%'"+">"+"序号"+"</td>"+
          "<td"+" align='center'"+" style='width:10%'"+">"+"销售金额"+"</td>"+
          "<td"+" align='center'"+" style='width:10%'"+">"+"应交款项"+"</td>"+
          "<td"+" align='center'"+" style='width:70%'"+">"+"备注"+"</td>"+
          "</tr><table>";
          $("#model0").append(sss);

          //子表表头
          let sss2= "<table"+" id=tab_3_ width=100%"+" style='border-collapse:collapse;font-size: 15px;'"+">";

          let count=Math.ceil( (data[1].length)/7 );//子表共有几页
          //console.log(count);
          //设置 计数div 的value 为 count
          $("#ipt_count").val(count);
          $("#div_box").val(data[1].length);
          for (let i=0;i<count;i++){
              if(i==0){
                  let div_box="<div"+" id="+"div_model"+i+"></div>";
                  $("#model1").append(div_box);
              }else{
                  let div_box="<div"+" id="+"div_model"+i+" style='display:none;'"+"></div>";
                  $("#model1").append(div_box);
              }

          }
          //有几页，创建一个div模型
          let p=0;
          let sss3="";

                  for(let i=0 , a=1;i<data[1].length;i++,a++){
                      console.log("每一条信息---"+data[1][i].INX+"--");
                      let  xsje=data[1][i].XSJE;
                      if(data[1][i].XSJE==null){
                          xsje="";
                      }

                      if(a<=7){
                          sss3+="<tr>"+
                              "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+data[1][i].INX+"</td>"+
                              "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+xsje+"</td>"+
                              "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+data[1][i].KKJE+"</td>"+
                              "<td"+" align='center'"+" style='width:70%;    border: 1px solid #000000;'"+">"+data[1][i].BZ+"</td>"+
                              "</tr>";
                          if(a==7 || a==data[1].length){
                              sss3+="</table>";
                              console.log("sss2:"+sss2);
                              console.log("sss3:"+sss3);
                              $("#div_model"+p).append(sss2+sss3);``
                              p++;
                              sss3="";//清空
                          }
                      }else{
                          if( a>7*p && a<=7*(p+1) && 7*(p+1)<=data[1].length){
                              sss3+="<tr>"+
                                  "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+data[1][i].INX+"</td>"+
                                  "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+xsje+"</td>"+
                                  "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+data[1][i].KKJE+"</td>"+
                                  "<td"+" align='center'"+" style='width:70%;    border: 1px solid #000000;'"+">"+data[1][i].BZ+"</td>"+
                                  "</tr>";
                              if( a==7*(p+1) ){
                                  sss3+="</table>";
                                  $("#div_model"+p).append(sss2+sss3);
                                  p++;
                                  sss3="";//清空
                              }
                              if ( (i+1)==data[1].length ){
                                  sss3+="</table>";
                                  $("#div_model"+p).append(sss2+sss3);
                              }
                          }else if( a>7*p && a<=7*(p+1) && 7*(p+1)>=data[1].length ){
                              //前面2个条件限定每一页的数量，后面的条件判断你是不是超过了表格原本的条数
                              sss3+="<tr>"+
                                  "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+data[1][i].INX+"</td>"+
                                  "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+xsje+"</td>"+
                                  "<td"+" align='center'"+" style='width:10%;    border: 1px solid #000000;'"+">"+data[1][i].KKJE+"</td>"+
                                  "<td"+" align='center'"+" style='width:70%;    border: 1px solid #000000;'"+">"+data[1][i].BZ+"</td>"+
                                  "</tr>";
                              if( a==7*(p+1) ){
                                  sss3+="</table>";
                                  $("#div_model"+p).append(sss2+sss3);
                                  p++;
                                  sss3="";//清空
                              }
                              if ( (i+1)==data[1].length ){
                                  sss3+="</table>";
                                  $("#div_model"+p).append(sss2+sss3);
                              }
                              if( (i+1)>data[1].length ){
                                  continue;
                              }
                          }
                      }
                  }
          let hdjc="";
          let hdjczj="";
          if(data[3][0]==null){
              hdjc="";
          }else {
              hdjc=data[3][0].HDJC;
          }
          if(hdjc==null){
              hdjc="";
              hdjczj="";
          }else{
              hdjczj=this.changeMoneyToChinese(data[3][0].HDJC);
          }
          //不带分页的表格尾部
              let sss4="<table"+" id=tab_4"+" width=100%"+" style='border-collapse:collapse;font-size:17px;'"+">"+
                  "<tr>"+
                  "<td"+" align='right'"+">"+"活动加抽总计"+"</td>"+
                  "<td"+" align='center'"+">"+hdjc+"</td>"+
                  "<td>"+hdjczj+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+" align='right'"+" style='font-size:17px;'"+">"+"开票金额"+"</td>"+
                  "<td"+" align='center'"+">"+data[6][0].JSJE+"</td>"+
                  "<td>"+this.changeMoneyToChinese(data[6][0].JSJE)+"</td>"+
                  "</tr>"+
                  "</table>"
                  +"<table"+" id=tab_5"+" width=100%"+" style='border-collapse:collapse;'"+">"+
                  "<tr>"+
                  "<td"+" align=right"+" style='font-size:15px;'"+" colspan="+">"+"联系人电话:"+"</td>"+
                  "<td"+" style='font-size:15px;'"+" colspan=2"+">"+phone+"</td>"+
                  "<td"+" style='font-size:15px;'"+" align='right'"+">"+"联系人:"+"</td>"+
                  "<td"+" style='font-size:15px;'"+" colspan=2"+">"+people+"</td>"+
                  "<td"+" style='font-size:15px;'"+">"+"第1页/共1页"+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+" colspan=8"+" style='font-size:15px;'"+">"+"备注：第二联财务存根联签字或盖章确认后与发票一起交回海雅财务部，谢谢配合！"+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+" align='right'"+" style='font-size:15px;'"+"  colspan=7"+">"+"商户签字或盖章确认:"+"</td>"+
                  "<td"+">"+""+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+"  colspan=6"+">"+""+"</td>"+
                  "<td"+" align='right'"+" style='font-size:15px;'"+">"+"日期:"+"</td>"+
                  "<td>"+""+"</td>"+
                  "</tr>"+
                  "</table>";
          //带分页的表格尾部
              let sss5="<table"+" id=tab_4"+" width=100%"+" style='border-collapse:collapse;font-size:17px;'"+">"+
                  "<tr>"+
                  "<td"+" align='right'"+">"+"活动加抽总计"+"</td>"+
                  "<td"+" align='center'"+">"+hdjc+"</td>"+
                  "<td>"+hdjczj+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+" align='right'"+" style='font-size:15px;'"+">"+"开票金额"+"</td>"+
                  "<td"+" align='center'"+">"+data[6][0].JSJE+"</td>"+
                  "<td>"+this.changeMoneyToChinese(data[6][0].JSJE)+"</td>"+
                  "</tr>"+
                  "</table>"
                  +"<table"+" id=tab_5"+" width=100%"+" style='border-collapse:collapse;page-break-after: always;'"+">"+
                  "<tr>"+
                  "<td"+" align=right"+" style='font-size:15px;'"+" colspan=3"+">"+"联系人电话:"+"</td>"+
                  "<td"+" style='font-size:15px;'"+" colspan=2"+">"+phone+"</td>"+
                  "<td"+" style='font-size:15px;'"+" align='right'"+">"+"联系人:"+"</td>"+
                  "<td"+" style='font-size:15px;'"+" colspan=2"+">"+people+"</td>"+
                  "<td"+" style='font-size:15px;'"+">"+"第"+($("#ipt").val()+1)+"页/共"+count+"页"+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+" colspan=8"+" style='font-size:15px;'"+">"+"备注：第二联财务存根联签字或盖章确认后与发票一起交回海雅财务部，谢谢配合！"+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+" align='right'"+" style='font-size:15px;'"+"  colspan=7"+">"+"商户签字或盖章确认:"+"</td>"+
                  "<td"+">"+""+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+"  colspan=6"+">"+""+"</td>"+
                  "<td"+" align='right'"+" style='font-size:15px;'"+">"+"日期:"+"</td>"+
                  "<td>"+""+"</td>"+
                  "</tr>"+
                  "</table>";



          let div5="<div"+" class="+"table_"+"  id=model5"+" name="+"model"+"></div>";
          let div6="<div"+" class="+"table_"+"  id=model6"+" name="+"model"+"></div>";
          $("#model2").append(div5);
          $("#model3").append(div6);
          $("#model5").append(sss4);
          $("#model6").append(sss5);


          $("#tab_0  td").css("width","120px");

          $("#tab_1  td").css("width","140px");
          $("#tab_1  td").css("height","25px");
          $("#tab_1 td").css("border","1px solid");

          $("#tab_2  td").css("width","140px");
          $("#tab_2  td").css("height","25px");
          $("#tab_2 td").css("border","1px solid");

          $("#tab_3 td").css("border","1px solid");
          $("#tab_3_1 td").css("border","1px solid");
          $("#tab_4 td").css("border","1px solid");
          $("#tab_5  td").css("width","140px");
          $("#tab_5  td").css("height","25px");

      }else{

          sss+="<table"+"   id=tab_0"+" width=100%"+" style='border-collapse:collapse;'"+">"+
              "<tr>"+
              "<td"+" align=center"+" colspan=12"+" style='font-size:20px;'"+">"+"开  票  确  认  单"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=5"+" style='font-size:15px;'"+">"+"交  增  值  税  发  票  时  间"+"</td>"+
              "<td"+" colspan=4"+" align='right'"+" style='font-size:15px;'"+">"+data[11][0].RQ+"</td>"+
              "<td"+" colspan=3"+" style='font-size:15px;'"+">"+"前"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=12"+" style='font-size:15px;'"+">"+"（开票金额中未包括代扣费用）注：如未按以上时间交票，则贵司货款结算延顺至下一期。开具增值税发票"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=12"+" style='font-size:15px;'"+">"+"“货物或应税劳务名称”至少填写所售货物5项分类（或附销货清单），否则拒收该增值税票。 "+"</td>"+
              "</tr></table>";

          sss+="<table"+"   id=tab_1"+" width=100%"+" style='border-collapse:collapse;'"+">"+
              "<tr>"+
              "<td"+" align='center'"+">"+"代码"+"</td>"+
              "<td align='center'>"+data[8][0].HTH+"</td>"+
              "<td"+" colspan=2"+" align='center'"+">"+"供货商"+"</td>"+
              "<td"+" colspan=4"+" align='center'"+">"+data[8][0].GHDW+"</td>"+
              "<td"+" align='center'"+">"+"品牌"+"</td>"+
              "<td"+" colspan=3"+" align='center'"+">"+data[8][0].PP+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" align='center'"+">"+"应收金额"+"</td>"+
              "<td"+" align='center'"+">"+"月底保额"+"</td>"+
              "<td"+" align='center'"+">"+"合同扣率"+"</td>"+
              "<td"+" align='center'"+">"+"销售扣款"+"</td>"+
              "<td"+" align='center'"+">"+"补（退）销"+"</td>"+
              "<td"+" align='center'"+">"+"保底清算"+"</td>"+
              "<td"+" align='center'"+">"+"签呈降扣"+"</td>"+
              "<td"+" align='center'"+">"+"合同降扣"+"</td>"+
              "<td"+" align='center'"+">"+"九折补偿"+"</td>"+
              "<td"+" align='center'"+">"+"会员储点"+"</td>"+
              "<td"+" align='center'"+">"+"积分加抽"+"</td>"+
              "<td"+" align='center'"+">"+"商品推广"+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" align='center'"+">"+data[7][0].XSJE+"</td>"+
              "<td"+" align='center'"+">"+data[12][0].BDXSJH+"</td>"+
              "<td"+" align='center'"+">"+data[10][0].JSKL_HT+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].KKJE+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].BTX+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].BDQS+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].QCJK+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].HTJK+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].JZBC+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].HYCD+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].JFJC+"</td>"+
              "<td"+" align='center'"+">"+data[7][0].SPTG+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td"+" colspan=7"+" align='right'"+">"+" 活  动  加  抽  总  计: "+"</td>"+
              "<td"+" colspan=5"+">"+data[7][0].HDJC+"</td>"+
              "</tr></table>";

          sss+="<table"+"   id=tab_2"+" width=100%"+" style='border-collapse:collapse;'"+">"+
              "<tr>"+
              "<td"+" align='center'"+" style='width:10%'"+">"+"序号"+"</td>"+
              "<td"+" colspan=2"+" align='center'"+" style='width:10%'"+">"+"销售金额"+"</td>"+
              "<td"+" colspan=3"+" align='center'"+" style='width:10%'"+">"+"扣款金额"+"</td>"+
              "<td"+" colspan=6"+" align='center'"+" style='width:70%'"+">"+"备注"+"</td>"+
              "</tr>";
          if(data[9].length != 0){
              //alert(data[9][0].XSJE==null);
              for(let i=0; i<data[9].length; i++){
                  let  xsje=data[9][i].XSJE;
                  if(data[9][i].XSJE==null){
                      xsje="";
                  }
                  sss+="<tr>"+
                      "<td"+" align='center'"+" style='width:10%'"+">"+data[9][i].INX+"</td>"+
                      "<td"+" colspan=2"+" align='center'"+" style='width:10%'"+">"+xsje+"</td>"+
                      "<td"+" colspan=3"+" align='center'"+" style='width:10%'"+">"+data[9][i].KKJE+"</td>"+
                      "<td"+" colspan=6"+" align='center'"+" style='width:70%'"+">"+data[9][i].BZ+"</td>"+
                      "</tr>";
              }
          }
          sss+="</table>";

          sss+="<table"+"  id=tab_3"+" width=100%"+" style='border-collapse:collapse;'"+">"+
              "<tr>"+
              "<td"+" colspan=3"+" align='center'"+" style='font-size:15px;'"+">"+"开票金额"+"</td>"+
              "<td"+" colspan=3"+" align='center'"+" style='font-size:15px;'"+">"+data[7][0].KPJE+"</td>"+
              "<td"+" colspan=6"+" align='center'"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[7][0].KPJE)+"</td>"+
              "</tr>"+
              "</table>";
          sss+="<table"+"   id=tab_4"+" width=100%"+" style='border-collapse:collapse;'"+">";
          if(count == 0){
              sss+="<tr>"+
                  "<td"+" colspan=10"+">"+""+"</td>"+
                  "<td"+" colspan=2"+" align='center'"+">"+"第1页/共1页"+"</td>"+
                  "</tr>";
          }else{
              sss+="<tr>"+
                  "<td"+" colspan=10"+">"+""+"</td>"+
                  "<td"+" colspan=2"+" align='center'"+">"+"第"+($("#ipt").val()+1)+"页/共"+count+"页"+"</td>"+
                  "</tr>";
          }

              sss+=  "<tr>"+
              "<td"+" colspan=8"+">"+""+"</td>"+
              "<td"+" align='right'"+" style='font-size:15px;'"+" colspan=2"+">"+"客户签字确认:"+"</td>"+
              "<td"+" align='center'"+" style='font-size:15px;'"+" colspan=2"+">"+""+"</td>"+
              "</tr>" +
              "</table>";

          $("#model0").append(sss);
          $("#tab_0  td").css("width","81px");
          $("#tab_0  td").css("height","25px");
          $("#tab_1  td").css("width","81px");
          $("#tab_1  td").css("height","25px");
          $("#tab_1 td").css("border","1px solid");
          $("#tab_2  td").css("width","81px");
          $("#tab_2  td").css("height","25px");
          $("#tab_2  td").css("border","1px solid");
          $("#tab_3  td").css("width","81px");
          $("#tab_3  td").css("height","25px");
          $("#tab_3  td").css("border","1px solid");
          $("#tab_4  td").css("width","81px");
          $("#tab_4  td").css("height","25px");
      }
    },
    changeMoneyToChinese(money){
      let cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
      let cnIntRadice = new Array("","拾","佰","仟"); //基本单位
      let cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
      let cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字

      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr=""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      if( money === "" ){
          return "";
      }
      money = parseFloat(money);
      if( money >= maxNum ){
          $.alert('超出最大处理数字');
          return "";
      }
      if( money==0 ){
          ChineseStr = cnNums[0]+cnIntLast+cnInteger;
          return ChineseStr;
      }
      money = money.toString(); //转换为字符串
      if( money.indexOf(".") == -1 ){
          IntegerNum = money;
          DecimalNum = '';
      }else{
          parts = money.split(".");
          IntegerNum = parts[0];
          DecimalNum = parts[1].substr(0,4);
      }
      if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
          let zeroCount = 0;
          let IntLen = IntegerNum.length;
          for(let i=0;i<IntLen;i++ ){
              let n = IntegerNum.substr(i,1);
              let p = IntLen - i - 1;
              let q = p / 4;
              let m = p % 4;
              if( n == "0" ){
                  zeroCount++;
              }else{
                  if( zeroCount > 0 ){
                      ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
              }
              if( m==0 && zeroCount<4 ){
                  ChineseStr += cnIntUnits[q];
              }
          }
          ChineseStr += cnIntLast;
          //整型部分处理完毕
      }
      if( DecimalNum!= '' ){//小数部分
          let decLen = DecimalNum.length;
          for(let i=0; i<decLen; i++ ){
              let n = DecimalNum.substr(i,1);
              if( n != '0' ){
                  ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
              }
          }
      }
      if( ChineseStr == '' ){
          //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
          ChineseStr += cnNums[0]+cnIntLast;
      }
      if( money.substring(money.length-2,money.length-1)===0   ){
          ChineseStr+='整';
      }
      return ChineseStr;
    }
  },
  mounted(){
    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/searchFPQRD?DJBH="+this.JLBH).then(resp=>{
      let ipt="<input type="+"hidden"+" id="+"ipt"+" value="+"0"+">";    //这个input输入框也要隐藏，他的  value 代表是第几页（0代表第一页，默认为0）
      let ipt_count="<input"+" id=ipt_count"+" value="+"0"+" type="+"hidden"+">";//需要隐藏的input ,这个 input 的value是 代表费用子表的记录页数
      let div_hidden="<div"+" id=model_hidden"+"></div>";//需要隐藏的div
      let div_box="<div"+" id="+"div_box"+" value="+"0"+"></div>"; //子表记录条数
      $(".mini-grid").append(ipt);
      $(".mini-grid").append(ipt_count);
      $(".mini-grid").append(div_hidden);
      $(".mini-grid").append(div_box);
      //获取页面跳转时传递的参数
      //开票确认单也要分页
      //默认显示第一页
      let div1="<div"+" class="+"preview"+"  id=model0"+" name="+"model"+"></div>";  //存放页面头
      let div2="<div"+" class="+"preview"+"  id=model1"+" name="+"model"+"></div>";  //存放子表
      let div3="<div"+" class="+"preview"+"  id=model2"+" name="+"model"+"></div>";  //存放页面尾
      let div4="<div"+" class="+"preview"+"  id=model3"+" name="+"model"+" style='display: none;'"+"></div>";  //存放  带有分页标识的表格 (默认隐藏)
      $(".mini-grid").append(div1);
      $(".mini-grid").append(div2);
      $(".mini-grid").append(div3);
      $(".mini-grid").append(div4);
      console.log("resp.data.data+"+resp.data.data)
      this.showDJ(resp.data.data,this.HSFS);
    });
  }
};
</script>

<style lang="scss" scoped>
</style>